/* eslint-env jquery, browser */
/* global Auth0LockPasswordless */
import metrics from 'modules/metrics';
import 'spectrum-colorpicker';

/* Export InteractiveWidget */
export default InteractiveWidget;

/*
 * InteractiveWidget
 */

function InteractiveWidget(selector, type, lockContainer) {
  if (!$.fn.spectrum) {
    throw new Error('InteractiveWidget requires `Spectrum` plugin to fully work.');
  }

  const self = this;
  // Get metrics instance
  this.metrics = metrics ? metrics : null;
  // Get handle of main selectors
  this.selector = selector;
  this.$selects = $(`${selector} .fake-select-cont`);
  this.$selectOptions = this.$selects.find('.select-options');
  this.$iconInput = $(`${selector} .icon-input`);
  this.disabledLIs = $(`${selector} [data-enable-criteria]`);
  this.$loadOverlay = $(`${selector} .load-overlay`) ? $(`${selector} .load-overlay`) : undefined;
  // Define type of lock
  this.type = type ? type : 'lock';
  // Set basic state
  this.mainMethod = '';
  this.fieldsReady = false;
  // Init options and starting state depending on lock type
  this.options = {};
  // Set container for the lock instance
  this.options.container = lockContainer ? lockContainer : '';
  // Overriden getImage method with debounced one
  this.getImage = this.debounce(this.getImage, 150);
  // Keep track of total user interactions
  this.userActionsCount = 0;
  // Keep track of last submitted mode (signin or signup)
  this.currMode = '';
  if (this.type !== 'passwordless') throw new Error('Only passwordless type is allowed');
  this.mainLock = new Auth0LockPasswordless(
    'FFM5kk2bVwxecbTHWXt15zrRJIX2Kvp3',
    'pwdlessdemo.auth0.com'
  );
  this.options.connections = ['google-oauth2', 'github'];
  this.colorSelector = '#passwordless-color';
  this.options.rememberLastLogin = false;
}

InteractiveWidget.prototype.debounce = function(func, wait, immediate) {
  let timeout;
  return function(...args) {
    let context = this;
    const later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

InteractiveWidget.prototype.init = function() {
  const self = this;
  this.initFields();
  this.getAllFields();
  this.setActiveOptions();
  if (this.type == 'lock') {
    this.mainLock[this.mainMethod](this.options, this.callbackFunc);
    this.onCloseLock();
  } else {
    this.mainLock[this.mainMethod](this.options);
    this.checkMagicLinkSuccess();
  }
  this.showFade();
  this.initColorPicker();
  this.loadFinished();
  this.bindEvents();
};

InteractiveWidget.prototype.checkMagicLinkSuccess = function() {
  const self = this;
  const hash = this.mainLock.parseHash(window.location.hash);
  const pwdLessTab = $('a[data-toggle="tab"][href="#interactive-passwordless-section"]');
  const lockContainer = $(`#${this.options.container}`);

  function onSuccess(profile) {
    const user = profile || { name: 'John Foo', email: 'foo@auth0.com' };
    pwdLessTab.tab('show');
    lockContainer.find('.auth0-lock').css('opacity', 0);
    self.addSuccessMessage(true, user, "You've finished testing interactive tutorial, nice!");
    setTimeout(() => {
      $('html').animate(
        {
          scrollTop: $(self.selector).parent().offset().top - 100
        },
        750
      );
    }, 800);
    self.initFields();
    self.noTryLoginTooltip = true; // hide try tooltip
  }

  if (hash && hash.error) {
    console.log('InteractiveWidget: error on login from magiclink');
  } else if (hash && hash.id_token) {
    // use id_token for retrieving profile.
    localStorage.setItem('id_token', hash.id_token);
    // retrieve profile
    self.mainLock.getProfile(hash.id_token, (err, profile) => {
      if (err) {
        // handle err
      } else {
        // use user profile
        // succcess!
        onSuccess(profile);
      }
    });
  }
};

InteractiveWidget.prototype.loadFinished = function() {
  const self = this;
  if (this.$loadOverlay) {
    setTimeout(() => {
      self.$loadOverlay.addClass('ready-hide');
      if (self.type == 'lock' || self.type == 'passwordless') {
        setTimeout(() => {
          self.showTryLogin();
        }, 1200);
      }
    }, 1000);
  }
};

// This assumes we have the spectrum library with its js and css
InteractiveWidget.prototype.initColorPicker = function() {
  const self = this;
  $(this.colorSelector).spectrum({
    preferredFormat: 'hex',
    showInput: true,
    color: '#EA5323',
    replacerClassName: 'spectrum-color-picker',
    move: this.debounce(color => {
      self.options.primaryColor = color.toHexString();
      self.getAllFields(true);
    }, 150)
  });
};

InteractiveWidget.prototype.initFields = function() {
  // Calculate fields height to create dropdown behaviour
  this.zeroHeightField = false;
  const self = this;
  this.$selectOptions.each((i, el) => {
    $(el).css('max-height', 'initial');
    const thisElHeight = $(el).outerHeight(true);
    if (thisElHeight == 0) {
      self.zeroHeightField = true;
    }
    $(el).attr('data-max-height', thisElHeight);
    $(el).css('max-height', 0);
  });
  if (!this.zeroHeightField) this.fieldsReady = true;
};

InteractiveWidget.prototype.dropdownEvent = function() {
  const self = this;
  this.$selects.on('click', e => {
    const $tar = $(e.target).closest('.fake-select-cont');
    if ($tar.closest('li').hasClass('lock-li-disabled')) return;
    const $tarOpts = $tar.find('.select-options');

    // If an option was clicked, go to that handler and close the dropdown
    if ($(e.target).hasClass('select-value')) {
      self.selectOptionHandler($(e.target));
      self.closeDropdown($tar, $tarOpts);
      return;
    }

    // General behaviour
    if ($tar.hasClass('open')) {
      // Close
      self.closeDropdown($tar, $tarOpts);
    } else {
      // Open
      self.openDropdown($tar, $tarOpts);
    }
  });
};

InteractiveWidget.prototype.openDropdown = function($tar, $tarOpts) {
  if ($tar.is('.disabled')) return;

  this.closeAllDropdowns();
  $tar.addClass('open');
  $tarOpts.css('max-height', $tarOpts.data('max-height'));
};

InteractiveWidget.prototype.closeDropdown = function($tar, $tarOpts) {
  $tar.removeClass('open');
  $tarOpts.css('max-height', 0);
};

InteractiveWidget.prototype.closeAllDropdowns = function() {
  this.$selects.removeClass('open');
  this.$selects.find('.select-options').css('max-height', 0);
};

InteractiveWidget.prototype.selectOptionHandler = function($tar) {
  const $select = $tar.closest('.fake-select-cont');
  $select.find('.select-value').removeAttr('data-selected');
  $tar.attr('data-selected', '');

  // disable allowLogin select and set it to true if initial screen is
  // login, and enable it otherwise
  const $allowLoginSelect = this.$selects.filter('[data-name="allowLogin"]');
  if ($select.attr('data-name') == 'initialScreen' && $tar.data('value') === 'login') {
    $allowLoginSelect.addClass('disabled');
    $allowLoginSelect.find('[data-value="true"]').attr('data-selected', '');
    $allowLoginSelect.find('[data-value="false"]').removeAttr('data-selected');
  } else {
    $allowLoginSelect.removeClass('disabled');
  }

  this.setActiveOptions();
  if ($select.attr('data-name') == 'icon') {
    this.iconInputUsed = false;
  }

  if (metrics) {
    metrics.lib().track('click:interactive:options');
  }

  this.getAllFields(true);
  this.userActionsCount += 1;
  if (this.userActionsCount >= 3 && !this.userDisplayedTryMsg) {
    this.showTryPasswordless();
    this.userDisplayedTryMsg = true;
  }
};

InteractiveWidget.prototype.inputHandler = function() {
  const self = this;
  this.$iconInput.on('input', () => {
    self.iconImgUrl = self.$iconInput.val();
    self.getImage(self.iconImgUrl, (err, success) => {
      if (success) {
        self.iconInputUsed = true;
        self.options.icon = self.iconImgUrl;
        self.getAllFields(true);
      } else {
        console.log('err');
        delete self.options.icon;
        self.getAllFields(true);
      }
    });
  });
};

InteractiveWidget.prototype.getImage = function(url, callback) {
  const img = new Image();
  img.src = url;
  img.onload = function() {
    callback(null, true);
  };
  img.onerror = function(err) {
    callback(err);
  };
};

InteractiveWidget.prototype.closeAllEvent = function() {
  // TO-DO: Optimize this thoroughly by checking first if a dropdown is open.
  const self = this;
  $('body').on('click', e => {
    const $tar = $(e.target);
    if (!$tar.closest('.fake-select-cont').length) {
      // If it's not a select close all selects
      self.closeAllDropdowns();
    }
  });
};

InteractiveWidget.prototype.bindEvents = function() {
  this.dropdownEvent();
  this.closeAllEvent();
  this.inputHandler();
  this.autoDissmissTry();
  if (this.type == 'lock') {
    this.tabChangeEvent();
    this.enterpriseReady();
    this.onLoginError();
    this.onLoginSuccess();
    this.switchEvent();
    this.onSignupSubmit();
  }
};

InteractiveWidget.prototype.setActiveOptions = function() {
  this.$selects.each((i, el) => {
    let currOptVal = $(el).find('[data-selected]').attr('data-value');
    const currOpt = $(el).find('.current-option');
    if ($(el).attr('data-name') == 'dict') {
      currOpt.attr('data-value', currOptVal);
      currOptVal = currOptVal.toUpperCase();
    } else if ($(el).attr('data-name') == 'icon') {
      currOpt.attr('data-value', currOptVal);
    }
    currOpt.text(currOptVal);
  });
};

InteractiveWidget.prototype.toggleDisabled = function() {
  if (this.mainMethod == 'social') {
    this.disabledLIs.filter('[data-enable-criteria="social"]').removeClass('lock-li-disabled');
    this.disabledLIs.filter('[data-enable-criteria="non-social"]').addClass('lock-li-disabled');
  } else {
    this.disabledLIs.filter('[data-enable-criteria="social"]').addClass('lock-li-disabled');
    this.disabledLIs.filter('[data-enable-criteria="non-social"]').removeClass('lock-li-disabled');
  }
};

InteractiveWidget.prototype.showFade = function() {
  const self = this;
  $(this.selector).removeClass('a0-lock-ready');
  setTimeout(() => {
    $(self.selector).addClass('a0-lock-ready');
  }, 80);
};

InteractiveWidget.prototype.onCloseLock = function() {
  const self = this;
  this.mainLock.lock.on('close', () => {
    self.addCloseMessage();
    self.timer = setTimeout(() => {
      self.getAllFields(true);
    }, 3000);
  });
};

InteractiveWidget.prototype.onSignupSubmit = function() {
  const self = this;

  this.mainLock.lock.on('signup submit', () => {
    self.signupMailFieldValue = self.signupMailField.val();
  });
};

InteractiveWidget.prototype.onLoginSuccess = function() {
  const self = this;

  this.mainLock.lock.on('signin success', () => {
    self.currMode = 'signin';

    if (metrics) {
      metrics.lib().track('success:interactive:signin');
    }
  });

  this.mainLock.lock.on('signup success', () => {
    self.currMode = 'signup';

    self.callbackFunc();

    if (metrics) {
      metrics.lib().track('success:interactive:signup');
    }
  });
};

InteractiveWidget.prototype.onLoginError = function() {
  const self = this;
  this.mainLock.lock.on('signin error', () => {
    // console.log('signin error event');
  });

  this.mainLock.lock.on('signup error', () => {
    // console.log('signup error event');
  });

  this.mainLock.lock.on('error shown', () => {
    // console.log('generic error event');
    setTimeout(() => {
      self.$errorMessage = $(`${self.selector} .a0-error`);
      self.$errorMessage.show();
      setTimeout(() => {
        self.$errorMessage.addClass('error-slideUp');
        self.$errorMessage.on('transitionend', () => {
          self.$errorMessage.hide();
          self.$errorMessage.removeClass('error-slideUp');
        });
      }, 2500);
    }, 15);
  });
};

InteractiveWidget.prototype.showTryLogin = function(hide) {
  if (this.type == 'passwordless' && this.noTryLoginTooltip) return;
  const self = this;
  const appendTarget = $(this.selector);
  const msgCont = $('<div class="try-login"></div>');
  const msgString =
    '<span class="try-login-close">×</span><span>You can signup and login. <a href="#" class="try-login-btn">Try signing up first.</a></span>';

  if (hide && $('.try-login', appendTarget).length) {
    return $('.try-login', appendTarget).removeClass('ready');
  }

  msgCont.html(msgString);
  appendTarget.append(msgCont);
  this.tryLoginMessage = msgCont;
  setTimeout(() => {
    msgCont.addClass('ready');
  }, 100);
  msgCont.find('.try-login-btn').on('click', e => {
    e.preventDefault();
    // Here focus the email input
    // var a0switch = $(self.selector + ' .a0-switch span');
    // if (a0switch.length) a0switch.trigger('click');
    const emailInput = $('#a0-signup_easy_email');
    setTimeout(() => {
      if (emailInput.length) $('#a0-signup_easy_email').focus();
    }, 20);
    msgCont.removeClass('ready');
  });
  $('.try-login-close').on('click', () => {
    msgCont.removeClass('ready');
  });
};

InteractiveWidget.prototype.showTryPasswordless = function() {
  const self = this;
  const lockHeader = $(`${this.selector} .a0-header`);
  const msgCont = $('<div class="try-passwordless"></div>');
  const msgString =
    '<span class="try-passwordless-close">×</span><span>Now that you\'ve tested the lock, you can try Passwordless<a href="#" class="try-passwordless-btn">Try it now!</a></span>';
  msgCont.html(msgString);
  lockHeader.append(msgCont);
  this.tryLoginMessage.removeClass('ready');
  this.tryPasswordlessMessage = msgCont;
  msgCont.addClass('ready');
  msgCont.find('.try-passwordless-btn').on('click', e => {
    e.preventDefault();
    $('a[data-toggle="tab"][href="#interactive-passwordless-section"]').tab('show');
    msgCont.removeClass('ready');
  });
  $('.try-passwordless-close').on('click', () => {
    msgCont.removeClass('ready');
  });
};

InteractiveWidget.prototype.autoDissmissTry = function() {
  const self = this;
  const btnSelector = self.type === 'lock' ? '.a0-next.a0-primary' : '.auth0-lock-submit';

  $(this.selector).on('click', btnSelector, () => {
    self.showTryLogin(true);
  });
};

InteractiveWidget.prototype.switchEvent = function() {
  const self = this;
  const a0switch = $(`${self.selector} .a0-switch span`);
  // Check the switch exists or call again
  if (a0switch.length) {
    const tryLoginMsg = $(`${self.selector} .try-login`);
    // Check the login message exists or call again
    if (tryLoginMsg.length) {
      a0switch.on('click', e => {
        if (tryLoginMsg.hasClass('ready')) {
          tryLoginMsg.removeClass('ready');
        }
      });
    } else {
      setTimeout(() => {
        self.switchEvent();
      }, 20);
    }
  } else {
    setTimeout(() => {
      self.switchEvent();
    }, 20);
  }
};

InteractiveWidget.prototype.addSuccessMessage = function(signup, profile, customMsg) {
  const self = this;
  const successContainer = $('<div class="success-cont"></div>');
  const userName = profile ? ` ${profile.name}` : '';
  const userMail = profile ? ` ${profile.email}` : '';
  let successMessage = '';

  if (signup) {
    successMessage = `<p class="success-message">Thanks for registering${userName}.</p>`;
  } else {
    successMessage = `<p class="success-message">Thanks for logging in${userName}.</p><a href="#" class="success-try-passwordless-btn">Try Passwordless</a>`;
  }

  if (customMsg) {
    successMessage = `<p class="success-message">${customMsg}</p>`;
  }

  const checkmarkTemplate =
    '<svg width="56px" height="56px" viewBox="0 0 52 52" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="checkmark"><circle cx="26" cy="26" r="25" fill="none" class="checkmark__circle"></circle><path fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" class="checkmark__check"></path></svg>';

  successContainer.html(checkmarkTemplate + successMessage);

  const insertionPoint = $(`#${this.options.container}`);
  insertionPoint.css('height', '465px');
  insertionPoint.append(successContainer);
  $('.success-try-passwordless-btn').on('click', e => {
    e.preventDefault();
    $('a[data-toggle="tab"][href="#interactive-passwordless-section"]').tab('show');
  });
};

InteractiveWidget.prototype.addCloseMessage = function() {
  const closeContainer = $('<div class="close-cont"></div>');
  const closeMessage = '<p class="close-message">You closed the lock successfully.</p>';
  const checkmarkTemplate =
    '<svg width="56px" height="56px" viewBox="0 0 52 52" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="checkmark"><circle cx="26" cy="26" r="25" fill="none" class="checkmark__circle"></circle><path fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" class="checkmark__check"></path></svg>';
  closeContainer.html(checkmarkTemplate + closeMessage);
  const insertionPoint = $(`#${this.options.container}`);
  insertionPoint.append(closeContainer);
};

InteractiveWidget.prototype.tabChangeEvent = function() {
  const self = this;

  this.mainLock.lock.on('signin ready', () => {
    self.signinEmailInput = $('#a0-signin_easy_email');
    self.signinPasswordInput = $('#a0-signin_easy_password');
    if (self.writeEmail) {
      self.signinEmailInput.val(self.signupMailFieldValue);
      self.signinPasswordInput.focus();
      self.writeEmail = !self.writeEmail;
    }
    self.showFade();
    self.centerEverything();
  });

  this.mainLock.lock.on('signup ready', () => {
    self.signupMailField = $('#a0-signup_easy_email');
    self.showFade();
    self.centerEverything();
  });

  this.mainLock.lock.on('reset ready', () => {
    self.showFade();
    self.centerEverything();
  });
};

InteractiveWidget.prototype.enterpriseReady = function() {
  const self = this;

  this.mainLock.lock.on('enterprise ready', () => {
    self.showFade();
    self.centerEverything();
  });
};

InteractiveWidget.prototype.centerEverything = function() {
  const self = this;
  // We need to wrap this in a timeout to allow the DOM to refresh (Better solutions are welcome)
  setTimeout(() => {
    if (
      $(`${self.selector} .a0-lock form`).length ||
      $(`${self.selector} .auth0-lock-content`).length
    ) {
      if (self.type == 'lock') {
        self.paddingTarget = $(`${self.selector} .a0-lock form`);
        self.lockOuter = $(`${self.selector} .a0-lock`);
      } else if (self.type == 'passwordless') {
        // self.paddingTarget = $(`${self.selector} .auth0-lock-content`);
        self.lockOuter = $(`${self.selector} .auth0-lock`);
      }

      self.targetHeight = 465;
      self.diffHeight = self.targetHeight - self.lockOuter.height();

      // Leave this for debugging purposes
      // console.log(self.diffHeight + " = " + self.targetHeight + '-' + self.lockOuter.height() );

      // Only check its not 0, this works both for positive and negative values.
      // (in the case of a negative number, nothing can be done, it will just overflow)
      if (self.diffHeight) {
        const currPaddingTop = parseInt(self.paddingTarget.css('padding-top'));
        const currPaddingBottom = parseInt(self.paddingTarget.css('padding-bottom'));
        var totalPadTop = currPaddingTop + self.diffHeight / 2;
        var totalPadBottom = currPaddingBottom + self.diffHeight / 2;
        if (!(self.diffHeight % 2)) {
          // Even
          var totalPadTop = currPaddingTop + self.diffHeight / 2;
          var totalPadBottom = currPaddingBottom + self.diffHeight / 2;
          self.paddingTarget.css('padding-top', totalPadTop).css('padding-bottom', totalPadBottom);
        } else {
          // Odd
          var totalPadTop = currPaddingTop + (self.diffHeight - 1) / 2;
          var totalPadBottom = currPaddingBottom + (self.diffHeight - 1) / 2;
          self.paddingTarget
            .css('padding-top', totalPadTop)
            .css('padding-bottom', totalPadBottom + 1);
        }
      }
    }
  }, 10);
};

InteractiveWidget.prototype.getAllFields = function(bool) {
  const self = this;
  this.$selects.each((i, el) => {
    const elName = $(el).attr('data-name');
    let elVal = $(el).find('[data-selected]').attr('data-value');

    try {
      elVal = JSON.parse(elVal);
    } catch (e) {}

    if (elName == 'method') {
      self.mainMethod = elVal;
    } else if (elName == 'initialScreen') {
      self.mainMethod = 'show';
      const initialScreenModeMap = {
        login: 'signin',
        signUp: 'signup',
        forgotPassword: 'reset'
      };
      self.options.mode = initialScreenModeMap[elVal];
    } else if (elName == 'allowLogin') {
      self.options.disableSignupAction = !elVal;
    } else if (elName == 'icon') {
      if (!self.iconInputUsed) {
        self.options[elName] = `/pages/homepage/${elVal}`;
      }
    } else {
      self.options[elName] = elVal;
    }
  });
  // Check all disabled and enabled lines according to their criteria
  this.toggleDisabled();

  // Manage exceptions according to lock type
  if (this.type == 'lock') {
    if (this.options.connections.indexOf('auth0') != -1) {
      this.options.connections.push('auth0.com');
    }
  }

  if (this.type == 'passwordless') {
    if (this.mainMethod == 'social') {
      this.options.popup = true;
    }
  }

  // If we get a true argument, then refresh the lock
  if (bool) {
    // Clear timers to avoid refreshing the lock in case the user interacts with it
    if (this.timer) {
      clearTimeout(self.timer);
    }
    if (this.type == 'passwordless') {
      this.mainLock.close();
      this.mainLock[this.mainMethod](this.options);
      this.showFade();
      this.centerEverything();
    } else if (this.type == 'lock') {
      this.mainLock[this.mainMethod](this.options, this.callbackFunc);
      $(this.selector).attr('data-lang', this.options.dict);
      this.showFade();
      this.centerEverything();
    } else {
    }
  }
  $(this.selector).removeClass(
    'method-showSignin method-show method-showSignup method-showReset method-magiclink method-sms method-emailcode method-social'
  );
  $(this.selector).addClass(`method-${this.mainMethod}`);
};



// WEBPACK FOOTER //
// ./src/modules/interactive-widget/interactive-widget.js